import axios from 'axios'

const API_URL = (process.env.REACT_APP_TOKEN_API_URL ?? '').trim()

export interface TokenExchangeResponse {
  access_token: string
  token_type?: string
  expires_in?: number
  refresh_token?: string
}

function messageFromAxiosError(error: unknown): string {
  if (!axios.isAxiosError(error)) {
    return error instanceof Error ? error.message : 'Error desconocido'
  }
  const data = error.response?.data as Record<string, unknown> | string | undefined
  if (typeof data === 'string' && data.trim()) return data.trim()
  if (data && typeof data === 'object') {
    const desc = data.error_description
    const err = data.error
    if (typeof desc === 'string' && desc) return desc
    if (typeof err === 'string' && err) return err
  }
  return error.message || `HTTP ${error.response?.status ?? '?'}`
}

const env = (key: string): string =>
  (process.env[key] ?? '').trim()

export const exchangeCodeForToken = async (
  code: string
): Promise<TokenExchangeResponse> => {
  const params = new URLSearchParams()
  params.append('grant_type', 'authorization_code')
  params.append('code', code)
  params.append('redirect_uri', env('REACT_APP_OAUTH_REDIRECT_URI'))

  const basicAuth = btoa(
    `${env('REACT_APP_CLIENT_ID')}:${env('REACT_APP_CLIENT_SECRET')}`
  )

  try {
    const response = await axios.post<TokenExchangeResponse>(API_URL, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Basic ${basicAuth}`
      }
    })

    if (!response.data?.access_token) {
      throw new Error(
        'El servidor de token no devolvió access_token. Revisa la respuesta del OAuth.'
      )
    }

    return response.data
  } catch (error) {
    console.error('Error obtaining token', error)
    throw new Error(messageFromAxiosError(error))
  }
}
